var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"btn status_color_text",style:({ 'background-color': _vm.getBackgroundColor() }),on:{"click":_vm.openModal}},[_vm._v(_vm._s(_vm.payload.status))])
}
var staticRenderFns = []

export { render, staticRenderFns }